import React, {useState, useEffect } from 'react'
import useStateRef from 'react-usestateref';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { updateProfileDetailsAction } from '../../middleware/updateProfileDetailsAction';

export const CbRegister = ({ containerObject, templateName, contentId, dataZone }) => {
    const [pwd, setPwd] = useState('');
    const [isRevealPwd, setIsRevealPwd] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [hasError, setHasError, hasErrorRef] = useStateRef(false);
    const [isLoading, setIsLoading] = useState(false);
    const [redirectURL, setRedirectUrl] = useState();
    const [errorMessage, setErrorMessage, setErrorMessageRef] = useStateRef();
    const [registerIntl, setRegisterIntl, registerIntlRef] = useStateRef(false);
    const redirectUrl = useSelector(state => state.redirectUrlReducer)
    const profile = useSelector(state => state.getProfileDetails.profileDetails)
    const [currentUrl, setCurrentUrl] = useState()
    //const redirectUrl = useSelector(state => state.forgotPasswordMsgReducer)
    const dispatch = useDispatch();
    const history = useHistory()
    const [checkoutRegister, setCheckoutRegister] = useState(false)
    useEffect(() => {
        document.getElementById("register-form")?.reset()
        var searchParam = window.location.search
        var splitedUri = searchParam.split("?")
        if (splitedUri[1] == "intl=true") {
            setRegisterIntl(true)
            document.getElementById("school-radio")?.classList.add("d-none");
            // document.getElementById("yes-1")?.classList.add("d-none");
            // document.getElementById("yes-2")?.classList.remove("d-none");
            // document.getElementById("yes-2")?.classList.add("d-block");
        }
        var url = history.location.pathname
        console.log("login-page-url", url)
        var splitedUri = url.split("/")
        console.log("splitedUri", splitedUri)
        if (splitedUri && splitedUri[1] && splitedUri[2] && ((splitedUri[1] + "/" + splitedUri[2]) == "checkout/register" ||
            (splitedUri[1] + "/" + splitedUri[2]) == "checkout/register?intl=true")) {
            setCheckoutRegister(true)
        }
    }, [])

    useEffect(() => {
        var url = history.location.pathname
        var splitedUri = url.split("/")
        splitedUri && splitedUri[1] && splitedUri[2] ? setCurrentUrl(splitedUri[1] + "/" + splitedUri[2]) : "";
        if (profile) {
            console.log('currentUrl...',currentUrl);
            if (profile && profile.userType && currentUrl && currentUrl == "account/register") {
                window.location.href = "/"
            }
        }
    }, [profile])

    useEffect(() => {
        console.log("previousUrl-register", redirectUrl)
        setRedirectUrl(registerIntlRef.current ? "/checkout/int/save.jsp?create=true" : redirectUrl && redirectUrl.url)
    }, [redirectUrl])

    const toggleCheckbox = () => {
        setIsChecked(!isChecked);
    };
    const [showTooltip, setShowTooltip] = useState(false);
    const [showTooltip1, setShowTooltip1] = useState(false);

    const handleMouseEnter = () => {
        setShowTooltip(true);
    };

    const handleMouseLeave = () => {
        setShowTooltip(false);
    };
    const handleMouseEnter1 = () => {
        setShowTooltip1(true);
    };
    const handleMouseLeave1 = () => {
        setShowTooltip1(false);
    };

    function handleSubmit(event) {
        event.preventDefault();
        clearErrorMsg(setErrorMessageRef.current);
        //setHasError(false)
        var searchParam = window.location.search
        console.log("searchParam===>", searchParam)
        var splitedUri = searchParam.split("?")
        var actionUrl = event.target.getAttribute('action');
        var formData = new FormData(event.target);
        const formValue = Object.fromEntries(formData.entries());

        formValue["optIn"] = isChecked.toString();
        if (!("custType" in formValue)) {
            if (splitedUri[1] == "intl=true") {
                formValue["custType"] = "international";
            } else {
                formValue["custType"] = null;
            }
        }
        formValue["previousUrl"] = redirectURL;
        if(history.location.pathname == '/checkout/register'){
            formValue["previousUrl"] = '/checkout/register';
       }
            
        if (!hasErrorRef.current) {
            setHasError(false)
            // setIsLoading(true)
            fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/${actionUrl}`, {
                method: 'POST',
                headers: new Headers({
                    "content-Type": "application/json",
                }),
                body: JSON.stringify(formValue)
            }).then(res => res.json())
                .then(res => {
                    var responseObj = JSON.parse(res.response)
                    dispatch(updateProfileDetailsAction(true,"login"))
                    if (res.result === "success" && responseObj.status == "success") {
                        setIsLoading(false)
                        var redirectPageMap = JSON.parse(responseObj.response);
                        var redirectPage = redirectPageMap && redirectPageMap.redirectPage;
                        // b2c user
                        var messageFlag = 'true'
                        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/landing-message-success/${messageFlag}`, {
                            method: 'GET'
                        }).then(res => res.json())
                            .then(res => {
                                if (res.result === "success") {
                                    var response = (JSON.parse(res.response)).response
                                    var url = redirectPage;
                                    var modifiedUrl = url.replace(".jsp", "");
                                    console.log('modifiedUrl---b2c',modifiedUrl)
                                    history.push(modifiedUrl, response)
                                } else {
                                }
                            })
                            localStorage.clear();
                            formValue["email"] && window.heap.identify(formValue["email"]);
                    } else {
                        setIsLoading(false)
                        const errorList = responseObj.errorMessage;
                        handleRegistrationMessage(errorList)
                        setErrorMessage(errorList);
                    }
                })
        }
    }

    const clearErrorMsg = (errorList) => {
        document.getElementById("message-error-div").classList.remove("d-remove")
        document.getElementById("message-error-div").classList.add("d-none");
        var elems = document.querySelectorAll(".form-control");
        [].forEach.call(elems, function (el) {
            el.classList.remove("form-error");
        });
        errorList && errorList.map((item, index) => {
            document.getElementById(item.key.concat("_error")).innerHTML = '';
            document.getElementById(item.key.concat("_error")).classList.remove("d-block")
            document.getElementById(item.key.concat("_error")).classList.add("d-none")
        });
    }

    function handleRegistrationMessage(errorList) {
        document.getElementById("message-error-div").classList.remove("d-none");
        document.getElementById("message-error-div").classList.add("d-block");
        var scrollPos = document.getElementById("message-error-div").offsetTop;
        window.scrollTo({
            top: parseInt(scrollPos),
            behavior: 'smooth'
        })
        errorList && errorList.map((item, index) => {
            if (item.key !== 'userType') {
                document.getElementById("register_".concat(item.key)).classList.add("form-error")
            }
            document.getElementById(item.key.concat("_error")).innerHTML = item.message;
            document.getElementById(item.key.concat("_error")).classList.remove("d-none");
            document.getElementById(item.key.concat("_error")).classList.add("d-block");
        });
    }

    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content c-shop-list-detail`}>
            {profile && profile.transient ?
            <div className={` ${!checkoutRegister ? "row justify-content-center gx-0" : ""}`}>
                <div className="col-12 col-md-10 my-md-5 header-padding-row register my-2">
                    <div id="message-error-div" className="message message-red form-error-messages col-md-12 mx-auto">
                        <div className="col-12">
                            {/* <div id='resultExisitingError' style={{ color: "black" }} dangerouslySetInnerHTML={{ __html: setErrorMessageRef.current }}></div> */}
                            <div id='firstName_error' className='d-none text-dark'></div>
                            <div id='lastName_error' className='d-none text-dark'></div>
                            <div id='email_error' className='d-none text-dark'></div>
                            <div id='password_error' className='d-none text-dark'></div>
                            <div id='userType_error' className='d-none text-dark'></div>
                        </div>
                    </div>
                    <div className="text-left mt-3">
                        <h1 className="c-account-heading">Register New Online Account</h1>
                    </div>
                    <div className="text-left mt-3 mb-4">
                        {registerIntlRef.current ?
                            <p className="c-regular-text">
                                In order to submit your shopping cart to an international ordering representative, you will need an online account. Please fill in the fields below and click continue to proceed.
                            </p> :
                            <p className="c-regular-text">
                                Whether you're a teacher, purchasing manager, homeschooler, or business, everyone can create a login and enjoy the convenient features available at Carolina.com.
                            </p>
                        }
                    </div>
                    <form autoComplete='off' method="post" action="choose-account-type" id="register-form" className="c-account-page" onSubmit={handleSubmit} noValidate>
                        <div className="row g-3 mb-3">
                            <div className="col-md-4">
                                <label className="form-label" for="firstName">First Name</label>
                                <input maxlength="19" name="firstName" id="register_firstName" type="text" className="form-control" />
                            </div>
                        </div>
                        <div className="row g-3 mb-3">
                            <div className="col-md-4">
                                <label className="form-label" for="lastName">Last Name</label>
                                <input maxlength="19" name="lastName" id="register_lastName" type="text" className="form-control" />
                            </div>
                        </div>
                        <div className="row g-3 mb-3">
                            <div className="col-12 col-md-4">
                                <label className="form-email" for="email">Email</label>
                                <input autoComplete="new-password" maxlength="256" name="email" id="register_email" type="text" className="form-control c-read-only" />
                            </div>
                            <div className="col-12 col-md-8 choose-account-link">
                                <div className="form-check c-register-check">
                                    <input type="checkbox" className="form-check-input" onChange={toggleCheckbox} />
                                    {registerIntlRef.current == false ? <label id="yes-1" className="form-check-label" for="blankCheckbox">
                                        <strong>Yes</strong>, subscribe me to your newsletter.<br />You may opt out any time.<Link to="/help/terms-of-use" style={{ textDecoration: 'none' }} target="_blank"> Terms</Link> and <Link to="/help/privacy-and-security" style={{ textDecoration: 'none' }} target="_blank">Privacy Policy</Link>
                                    </label> :
                                    <label id="yes-2" className="form-check-label" for="blankCheckbox">
                                        <strong>Yes</strong>, Sign me up for exclusive offers
                                    </label> }
                                </div>
                            </div>
                        </div>
                        <div className="row g-3 mb-4">
                            <div className="col-md-4 register-pwd-div">
                                <label for="password" className="form-label">Password</label>
                                <div className="c-input-tooltip c-input-password register-password" style={{ position: 'relative' }} >
                                    <input autoComplete="new-password" name="password" id="register_password" type={isRevealPwd ? "text" : "password"} className="form-control" value={pwd} onChange={e => setPwd(e.target.value)}/>
                                    <Link className="c-register-passShow" style={{ textDecoration: 'none', position: 'absolute' }} id="show-password" onClick={() => setIsRevealPwd(prevState => !prevState)}>
                                        {isRevealPwd ? 'HIDE' : 'SHOW'}
                                    </Link>
                                    <span className="c-tooltip" onMouseEnter={handleMouseEnter}
                                        onMouseLeave={handleMouseLeave}
                                        style={{ position: 'relative' }}>
                                        <i className="bi bi-question-circle-fill"></i>
                                        {showTooltip && (
                                            <div className='register-password-tooltip tooltip-div' style={{
                                                position: 'absolute', top: '-74px', left: '-84px', background: '#fbf3bf', zIndex: '1', width: '200px',
                                                padding: '0.875rem', border: "0.063rem solid #ccc", boxShadow: '0 0 0.625rem #ccc', lineHeight: '1.125rem', letterSpacing: '0',
                                                color: '#333', borderRadius: '0.313rem', fontSize: '0.75rem', fontWeight: '400', textAlign: 'left'
                                            }}>
                                                <div className='tooltip-arrow register-password-tooltip-arrow' style={{
                                                    position: 'absolute', top: '65px', left: '50%', marginLeft: '-13px', width: '0', height: '0',
                                                    borderLeft: '5px solid transparent', borderRight: '5px solid transparent', borderTop: '7px solid #333',
                                                }}></div>
                                                Passwords must be at least 6 characters long.
                                            </div>
                                        )}
                                    </span>
                                </div>
                            </div>
                        </div>
                        {registerIntlRef.current ? '' : <div className="row">
                            <div id="school-radio" className="col-md-6  mb-3">
                                <div className="text-left">
                                    <p className="text-left c-regular-text">
                                        Are you ordering on behalf of school or business?
                                        <span className="c-tooltip m" onMouseEnter={handleMouseEnter1}
                                            onMouseLeave={handleMouseLeave1}
                                            style={{ position: 'relative', marginLeft: "5px" }}>
                                            <i className="bi bi-question-circle-fill"></i>
                                            {showTooltip1 && (
                                                <div className='institution-tooltip institution-tooltip-div' style={{
                                                    position: 'absolute', top: '-184px', left: '-88px', zIndex: '1', width: '200px', padding: '0.875rem',
                                                    backgroundColor: '#fbf3bf', border: '0.063rem solid #ccc', boxShadow: '0 0 0.625rem #ccc', lineHeight: '1.125rem',
                                                    letterSpacing: '0', color: '#333', borderRadius: '0.313rem', textAlign: 'left',
                                                    fontSize: '0.75rem', fontWeight: '400'
                                                }}>
                                                    <div className="institution-tooltip institution-tooltip-arrow" style={{
                                                        position: 'absolute', top: '172px', left: '53%', marginLeft: '-15px', width: '0', height: '0',
                                                        borderLeft: '5px solid transparent', borderRight: '5px solid transparent', borderTop: '7px solid #333',
                                                    }}></div>
                                                    If purchasing for a school or institution, select <strong>yes</strong> to link your online account to your school or institution's corporate account. Please Note: this corporate account must have an existing Net 30 account with carolina.
                                                </div>
                                            )}
                                        </span>
                                    </p>
                                </div>

                                <div className="form-check form-check-inline">
                                    <input name="custType" id="exampleRadios1" type="radio" value="institution" className="form-check-input" />
                                    <label className="form-check-label" for="exampleRadios1">
                                        Yes
                                    </label>
                                </div>&nbsp;
                                <div className="form-check form-check-inline">
                                    <input name="custType" id="exampleRadios2" type="radio" value="personal" className="form-check-input" />
                                    <label className="form-check-label" for="exampleRadios2">
                                        No
                                    </label>
                                </div>

                            </div>
                        </div> }
                        <div className="row g-3 mb-3">
                            <div className="col-md-4 d-grid">
                                {registerIntlRef.current ?
                                    <button type="submit" className="register-btn-primary block">
                                        Continue
                                    </button> :
                                    <button type="submit" className="register-btn-primary block">
                                        Complete Registration
                                    </button>
                                }
                            </div>
                        </div>
                    </form>

                </div>
            </div>:<></>
            }
        </div>
    )
}
